var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", { attrs: { disabled: _vm.loading } }, [
    _c("div", { staticClass: "mb-3" }, [
      _c("label", { attrs: { for: "first_name" } }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("booking.inputs.first_name.label")) +
            ":\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formData.first_name,
            expression: "formData.first_name",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          name: "first_name",
          id: "first_name",
          maxlength: "50",
          placeholder: _vm.$t("booking.inputs.first_name.placeholder"),
          required: "",
        },
        domProps: { value: _vm.formData.first_name },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formData, "first_name", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("label", { attrs: { for: "last_name" } }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("booking.inputs.last_name.label")) +
            ":\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formData.last_name,
            expression: "formData.last_name",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          name: "last_name",
          id: "last_name",
          maxlength: "50",
          placeholder: _vm.$t("booking.inputs.last_name.placeholder"),
          required: "",
        },
        domProps: { value: _vm.formData.last_name },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formData, "last_name", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("label", { attrs: { for: "email" } }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("booking.inputs.email.placeholder")) +
            ":\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formData.email,
            expression: "formData.email",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "email",
          name: "email",
          id: "email",
          maxlength: "255",
          placeholder: _vm.$t("booking.inputs.email.placeholder"),
          required: "",
        },
        domProps: { value: _vm.formData.email },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formData, "email", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("label", { attrs: { for: "phone" } }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("booking.inputs.phone.placeholder")) +
            ":\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formData.phone,
            expression: "formData.phone",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          name: "phone",
          id: "phone",
          maxlength: "50",
          placeholder: _vm.$t("booking.inputs.phone.placeholder"),
          required: "",
        },
        domProps: { value: _vm.formData.phone },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formData, "phone", $event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }